var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatherAlertOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.647,
    height: 56.647,
    viewBox: "0 0 56.647 56.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.132,3H39.514L54.647,18.132V39.514L39.514,54.647H18.132L3,39.514V18.132Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,12V22.329",
    transform: "translate(10.823 6.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,24h0",
    transform: "translate(10.823 15.153)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherAlertOctagon);
export default __webpack_public_path__ + "static/media/feather-alert-octagon.e853ca0b5adc15856c0de9aa80550154.svg";
export { ForwardRef as ReactComponent };